import type { ReactNode } from 'react';

import type { IconName } from './Icon';
import { IconChip } from './IconChip';

/**
 * Estado vazio.
 *
 * Base vazia e um estado normal de uma plataforma recem-instalada, e nao um erro.
 * A tela explica o que existe ali e oferece o proximo passo, em vez de exibir uma
 * area em branco que parece falha de carregamento.
 */
export function EmptyState({
  icon = 'layers',
  title,
  description,
  action,
}: {
  icon?: IconName | undefined;
  title: string;
  description?: string | undefined;
  action?: ReactNode | undefined;
}) {
  return (
    <div className="flex flex-col items-center justify-center px-6 py-14 text-center">
      {/* O halo em volta do chip e a moldura do estado vazio, na cor da empresa. */}
      <span className="rounded-[1.375rem] bg-brand-50/60 p-1.5 ring-1 ring-brand-100">
        <IconChip icon={icon} tone="brand" size="lg" />
      </span>
      <h3 className="mt-4 text-sm font-semibold text-ink-900">{title}</h3>
      {description ? (
        <p className="mt-1.5 max-w-sm text-sm text-ink-500">{description}</p>
      ) : null}
      {action ? <div className="mt-5">{action}</div> : null}
    </div>
  );
}
